module.exports = "<span data-ng-message=required>*required, at least one section check-box selection required to process the report</span> ";